import { GlobalOutlined, LockOutlined, CheckOutlined } from "@ant-design/icons";
import "./AccessSelector.css";

const OPTIONS = [
  {
    key: 1,
    title: "Restricted",
    description: "Only people you add can open this link",
    Icon: LockOutlined,
  },
  {
    key: 0,
    title: "Anyone with the link",
    description: "No sign-in needed — anyone can view",
    Icon: GlobalOutlined,
  },
];

/**
 * Access level, as two selectable cards rather than a dropdown.
 *
 * This is the most consequential choice in the dialog, so both outcomes stay on
 * screen with their consequence spelled out — a closed menu hides the option you
 * did not pick, which is exactly the one you need to weigh.
 */
export const AccessSelector = ({ type, setType }) => (
  <div className="access-selector" role="radiogroup" aria-label="General access">
    {OPTIONS.map(({ key, title, description, Icon }) => {
      const selected = key === type;
      return (
        <button
          type="button"
          key={key}
          role="radio"
          aria-checked={selected}
          className={`access-card ${selected ? 'access-card--selected' : ''}`}
          onClick={() => setType(key)}
        >
          <span className="access-card__icon">
            <Icon />
          </span>
          <span className="access-card__body">
            <span className="access-card__title">{title}</span>
            <span className="access-card__desc">{description}</span>
          </span>
          <span className="access-card__check">
            <CheckOutlined />
          </span>
        </button>
      );
    })}
  </div>
);

export default AccessSelector;
